import type { components } from '@fluencelabs/vodopad-admin-api'

type VmStatus = components['schemas']['UserVmStatusDto']
type StorageStatus = components['schemas']['UserStorageStatusDto']
type PublicIpStatus = components['schemas']['UserPublicIpStatusDto']
type AccountStatus = components['schemas']['AccountStatus']
type PaymentType = components['schemas']['PaymentType']

export const ACCOUNT_STATUSES: AccountStatus[] = [
  'Active',
  'PastDue',
  'Suspended',
  'Cleared',
]

export const ACCOUNT_STATUS_COLORS: Record<AccountStatus, string> = {
  Active: 'green',
  PastDue: 'orange',
  Suspended: 'red',
  Cleared: 'default',
}

export const PAYMENT_TYPES: PaymentType[] = ['Prepay', 'Postpay']

export const VM_STATUSES: VmStatus[] = [
  'new',
  'launching',
  'launched',
  'failed',
  'updating',
  'terminating',
  'terminated',
  'suspending',
  'suspended',
  'restarting',
  'softRebooting',
]

export const VM_TERMINAL_STATUSES = new Set<VmStatus>([
  'terminated',
  'terminating',
])

export const STORAGE_STATUSES: StorageStatus[] = [
  'new',
  'created',
  'ready',
  'updating',
  'failed',
  'removing',
  'removed',
]

export const STORAGE_TERMINAL_STATUSES = new Set<StorageStatus>([
  'removed',
  'removing',
])

export const PUBLIC_IP_STATUSES: PublicIpStatus[] = [
  'new',
  'created',
  'ready',
  'failed',
  'removing',
  'removed',
]

export const PUBLIC_IP_TERMINAL_STATUSES = new Set<PublicIpStatus>([
  'removed',
  'removing',
])

type VpcStatus = components['schemas']['UserVpcStatusDto']
type SubnetStatus = components['schemas']['UserSubnetStatusDto']

export const VPC_STATUSES: VpcStatus[] = [
  'new',
  'created',
  'ready',
  'failed',
  'removing',
  'removed',
]

export const SUBNET_STATUSES: SubnetStatus[] = [
  'new',
  'created',
  'ready',
  'failed',
  'removing',
  'removed',
]
